<div>

  <div class="cost-distribution">

    <!-- Filtros de tiempo -->
    <app-filters-time
      [priceKwh]="priceKwh"
      [activeFilter]="activeFilter"
      [customStartDate]="customStartDate"
      [customEndDate]="customEndDate"
      (filterChange)="onFilterChange($event)"
      (customDateChange)="onCustomDateChange($event)"
      (priceChange)="savePrice()"
      (monthSelected)="onMonthSelected($event)"
      [showPriceFilter]="false">
    </app-filters-time>

    <!-- Sección Subgrupos -->
    <div class="card shadow-sm" *ngIf="subgroups && subgroups.length > 0">
      <div class="card-header p-3 bg-dark text-white d-flex align-items-center justify-content-between cursor-pointer user-select-none my-rounded mb-0"
           (click)="toggleAccordion('subgroups')">
        <div class="d-flex align-items-center gap-3">
          <i class="fas fa-chevron-right transition-transform"
             [class.rotate-90]="subgroupsExpanded"></i>
          <span class="fw-semibold fs-4">Subgrupos</span>
          <!-- {{"subgroups" | translate }} ({{subgroups.length}}) -->
        </div>
      </div>

      <div class="collapse" [class.show]="subgroupsExpanded">
        <div class="card-body p-4">
          <div class="row g-3">

            <!-- tarjeta de subgrupo -->
            <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                 *ngFor="let subgroup of subgroups; let i = index">
              <label class="card h-100 border-2 cursor-pointer"
                     [class.border-primary]="isSubgroupSelected(subgroup.alias)"
                     [class.bg-primary-subtle]="isSubgroupSelected(subgroup.alias)">

                <!-- checkbox fantasma -->
                <input type="checkbox" class="d-none"
                       [checked]="isSubgroupSelected(subgroup.alias)"
                       (change)="onSubgroupSelectionChange($event, subgroup.alias)">

                <div class="card-body d-flex flex-column">
                  <!-- cabecera -->
                  <h6 class="card-title fw-semibold mb-2">{{ subgroup.name }}</h6>
                  <p class="card-text text-muted small mb-2">{{ subgroup.description }}</p>
                  <p class="card-text text-muted small mb-3">
                    {{ subgroup.devices?.length }} {{ 'devices' | translate }}
                  </p>

                  <!-- botón -->
                  <button class="btn btn-primary btn-sm mt-auto"
                          (click)="$event.stopPropagation(); toggleSubgroupDetails(i)">
                    {{ (subgroup.showDetails ? 'hideDetails' : 'moreDetails') | translate }}
                  </button>

                  <!-- lista de dispositivos -->
                  <ul *ngIf="subgroup.showDetails" class="list-unstyled mt-3 small">
                    <li *ngFor="let d of subgroup.devices" class="mb-2 pb-2 border-bottom">
                      <div class="fw-medium">{{ d.name || '—' }}</div>
                      <div class="text-muted">{{ d.serial }}</div>
                      <div class="text-muted">{{ d.total / 1000 }} kWh</div>
                    </li>
                  </ul>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sección Cargadores -->
    <div class="card shadow-sm">
      <div class="card-header p-3 bg-dark text-white d-flex align-items-center justify-content-between cursor-pointer user-select-none my-rounded mb-0"
           (click)="toggleAccordion('chargers')">
        <div class="d-flex align-items-center gap-3">
          <i class="fas fa-chevron-right transition-transform"
             [class.rotate-90]="chargersExpanded"></i>
          <span class="fw-semibold fs-4">Dispositivos</span>
          <!-- {{ "devices" | translate }}({{allChargers.length}}) -->
        </div>
      </div>

      <div class="collapse" [class.show]="chargersExpanded">
        <div class="card-body p-4">

          <!-- Filtros -->
          <div class="filters-section mb-3">
            <div class="row g-2">
              <!-- Filtro por tipo de dispositivo -->
              <div class="col-md-4">
                <label class="form-label small text-muted">{{ "deviceType" | translate }}</label>
                <select class="form-select form-select-sm" [(ngModel)]="selectedDeviceType" (ngModelChange)="applyFilters()">
                  <option value="">{{ "allTypes" | translate }}</option>
                  <option value="EVVC1">EVVC1 - Combi</option>
                  <option value="EVVC3">EVVC3 - Uni</option>
                  <option value="EVVC4">EVVC4 - CombiPlus</option>
                  <option value="EVVC5">EVVC5 - City+2</option>
                  <option value="EVVC6">EVVC6 - Exo</option>
                  <option value="XEO">XEO - XeoLum+</option>
                  <option value="ANC">ANC - AstroNovaCity</option>
                </select>
              </div>

              <!-- Filtro por versión de firmware -->
              <div class="col-md-4">
                <label class="form-label small text-muted">{{ "firmwareVersion" | translate }}</label>
                <select class="form-select form-select-sm" [(ngModel)]="selectedFirmwareVersion" (ngModelChange)="applyFilters()">
                  <option value="">{{ "allVersions" | translate }}</option>
                  <option *ngFor="let version of availableFirmwareVersions" [value]="version">{{ version }}</option>
                </select>
              </div>

              <!-- Filtro por estado de conexión -->
              <div class="col-md-4">
                <label class="form-label small text-muted">{{ "connectionStatus" | translate }}</label>
                <select class="form-select form-select-sm" [(ngModel)]="selectedConnectionStatus" (ngModelChange)="applyFilters()">
                  <option value="">{{ "allStatus" | translate }}</option>
                  <option value="true">{{ "online" | translate }}</option>
                  <option value="false">{{ "offline" | translate }}</option>
                </select>
              </div>
            </div>

            <!-- Botón para limpiar filtros -->
            <div class="d-flex justify-content-end mt-2">
              <button class="btn btn-outline-secondary btn-sm" (click)="clearFilters()" *ngIf="hasActiveFilters()">
                <i class="fas fa-times me-1"></i>
                {{ "clearFilters" | translate }}
              </button>
            </div>
          </div>


          <!-- Controles de vista -->
          <div class="d-flex justify-content-between align-items-center pb-3 border-bottom mb-3">
            <label class="checkbox-container">
              <!-- TEMPLATE -->
              <input type="checkbox" [checked]="isAllSelected" [indeterminate]="isIndeterminate"
                (change)="onSelectAllChange($event)">

              <span class="checkmark"></span>
              {{ "selectAll" | translate}}
            </label>

            <div class="btn-group btn-group-sm" role="group">
              <button type="button" class="btn"
                      [class.btn-primary]="currentView === 'list'"
                      [class.btn-outline-primary]="currentView !== 'list'"
                      (click)="onViewChange('list')">
                <i class="fas fa-list me-1"></i>
                {{ "deviceListing" | translate}}
              </button>
              <button type="button" class="btn"
                      [class.btn-primary]="currentView === 'grid'"
                      [class.btn-outline-primary]="currentView !== 'grid'"
                      (click)="onViewChange('grid')">
                <i class="fas fa-th-large me-1"></i>
                {{"cards_s" | translate }}
              </button>
            </div>
          </div>

          <div class="mb-3">
            <span class="text-muted small">
              <!-- seleccionados -->
              <strong>{{selectedDeviceIds.length}}</strong> de {{allDevices.length}} {{ "valuesSelected" | translate }}
            </span>
          </div>

          <!-- Vista listado -->
          <div class="chargers-list" *ngIf="currentView === 'list'">
            <div class="charger-item" *ngFor="let device of filteredDevices; let i = index" [class.selected]="isDeviceSelected(device.serial)">


            <label class="checkbox-container">
              <input type="checkbox" [checked]="isDeviceSelected(device.serial)"
                (change)="onDeviceSelectionChange($event, device.serial)">
              <span class="checkmark"></span>
            </label>


              <!-- Imagen del dispositivo principal -->
              <div>
                <!-- <img src="./../../../../assets/img/orbis/xeo+_2 2.png" alt="" srcset="" style="height: 30px;width: 40px;"> -->
                                       <img *ngIf="device.serial.includes('EVVC3')" src="./../../../../assets/img/orbis/uni.png" alt="uni"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC4')" src="./../../../../assets/img/orbis/combiplus.png"
                        alt="combiplus" style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC5')" src="./../../../../assets/img/orbis/city+2.png" alt="city+2"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC1')" src="./../../../../assets/img/orbis/combi.png" alt="combi"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC6')" src="./../../../../assets/img/orbis/exo.png" alt="exo"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('XEO')" src="./../../../../assets/img/orbis/xeo+_2 2.png" alt="" srcset="" style="height: 40px;width: 40px;">
                      <img *ngIf="device.serial.includes('ANC')" src="./../../../../assets/img/orbis/ANC.png" alt="" srcset="" style="height: 40px;">
              </div>

              <!-- Información del dispositivo (izquierda) -->
              <div class="charger-info-compact">
                <div class="device-name-status">
                  <div class="charger-name">{{ device.name }}</div>
                  <span class="status-badge" [ngClass]="getStatusClass(device.alive)">
                    {{getStatusText(device.alive)}}
                  </span>
                </div>
                <div class="charger-code">{{ device.serial }}</div>
              </div>

              <!-- Elementos de la derecha agrupados -->
              <div class="charger-right-section">
                <!-- Datos energéticos -->
                <div class="charger-data">
                  <div class="data-item">
                    <i class="fas fa-bolt"></i>
                    <span class="data-value">{{ device.totalEnergy  | number:'1.2-2' }} kWh</span>
                  </div>
                </div>

                <!-- Sección de satélites (consistente para todos los dispositivos) -->
                <div class="satellites-info">
                  <!-- Para dispositivos XEO con satélites -->
                  <div *ngIf="device.serial.includes('XEO')" class="satellite-container">
                    <div class="satellite-icon-wrapper">
                      <img src="./../../../../assets/img/orbis/XeoSwitch 1.png" alt="XeoSwitch" class="satellite-icon">
                      <span class="satellite-badge" [ngClass]="device.satelites?.length > 0 ? 'has-satellites' : 'no-satellites'">
                        {{ device.satelites?.length || 0 }}
                      </span>
                    </div>
                    <div class="satellite-label">Satélites</div>
                  </div>

                </div>

                <!-- Acciones -->
                <div class="charger-actions">
                  <button class="action-btn" (click)="openDeviceStatsModal(device)" data-bs-toggle="modal" data-bs-target="#deviceStatsModal">
                    <i class="fa-solid fa-chart-pie"></i>
                  </button>
                  <button class="action-btn" (click)="openDeviceInfoModal(device)" data-bs-toggle="modal" data-bs-target="#deviceInfoModal">
                    <i class="fa-solid fa-circle-info"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

              <!-- Vista tarjetas -->
              <div class="chargers-grid" *ngIf="currentView === 'grid'">
                <div class="charger-card" *ngFor="let device of filteredDevices; let i = index"
                  [class.selected]="isDeviceSelected(device.serial)">

                  <!-- Checkbox -->
                  <label class="checkbox-container card-checkbox">
                    <input type="checkbox" [checked]="isDeviceSelected(device.serial)"
                      (change)="onDeviceSelectionChange($event, device.serial!)">
                    <span class="checkmark"></span>
                  </label>

                  <!-- Cabecera con nombre/serial + imagen y estado -->
                  <div class="card-header d-flex justify-content-between align-items-start">
                    <!-- Nombre, estado y serial -->
                    <div>
                      <div class="d-flex align-items-center gap-2">
                        <span class="card-name">{{ device.name ? device.name : device.serial }}</span>

                        <!-- Punto de estado con tooltip -->
                        <span class="status-dot" [ngClass]="getStatusClass(device.alive)"
                          [attr.title]="getStatusText(device.alive)">
                        </span>
                      </div>

                      <div class="card-code">{{ device.serial }}</div>
                    </div>

                    <!-- Imagen -->
                    <div class="text-center">
                      <img *ngIf="device.serial.includes('EVVC3')" src="./../../../../assets/img/orbis/uni.png" alt="uni"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC4')" src="./../../../../assets/img/orbis/combiplus.png"
                        alt="combiplus" style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC5')" src="./../../../../assets/img/orbis/city+2.png" alt="city+2"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC1')" src="./../../../../assets/img/orbis/combi.png" alt="combi"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('EVVC6')" src="./../../../../assets/img/orbis/exo.png" alt="exo"
                        style="height: 35px;">
                      <img *ngIf="device.serial.includes('XEO')" src="./../../../../assets/img/orbis/xeo+_2 2.png" alt="" srcset="" style="height: 30px;width: 40px;">
                      <img *ngIf="device.serial.includes('ANC')" src="./../../../../assets/img/orbis/ANC.png" alt="" srcset="" style="height: 30px">
                    </div>
                  </div>


                  <!-- Datos -->
                  <div class="card-data">
                    <div class="card-data-item" *ngIf="device.serial.includes('EVVC')">
                      <div class="card-data-label"> {{ "lastCharge" | translate}} </div>
                      <div class="card-data-value">{{ device.historic?.[i]?.end_datetime ?
                        (device.historic?.[i]?.end_datetime | date:'dd/MM/yyyy') : '--/--/--' }}</div>
                    </div>
                    <!-- Información de satélites (solo para XEO) -->
                    <div class="card-data-item" *ngIf="device.serial.includes('XEO')">
                      <div class="card-data-label">
                        <i class="fas fa-satellite"></i> Satélites
                      </div>
                      <div class="card-data-value">
                        <span class="satellite-count" [ngClass]="device.satelites?.length > 0 ? 'text-success' : 'text-muted'">
                          {{ device.satelites?.length || 0 }}
                        </span>
                        <img src="./../../../../assets/img/orbis/XeoSwitch 1.png" alt="XeoSwitch" class="satellite-mini-icon">
                      </div>
                    </div>
                    <!-- Información de tipo (solo para ANC) -->
                    <div class="card-data-item" *ngIf="device.serial.includes('ANC')">
                      <div class="card-data-label">
                        <i class="fas fa-microchip"></i> Tipo
                      </div>
                      <div class="card-data-value">
                        <span class="device-type-badge">Astronómico</span>
                      </div>
                    </div>
                    <div class="card-data-item">
                      <div class="card-data-label"> {{"totalConsumption " | translate}} </div>
                      <div class="card-data-value">
                        {{ device.totalEnergy | number:'1.2-2' }} kWh
                      </div>
                    </div>
                    </div>

                  <!-- Acciones -->
                  <div class="card-actions">
                    <button class="action-btn" (click)="openDeviceStatsModal(device)" data-bs-toggle="modal" data-bs-target="#deviceStatsModal">
                      <i class="fa-solid fa-chart-pie"></i>
                    </button>
                    <button class="action-btn" (click)="openDeviceInfoModal(device)" data-bs-toggle="modal" data-bs-target="#deviceInfoModal">
                      <i class="fa-solid fa-circle-info"></i>
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>
    </div>

    <!-- Resumen de selección -->
    <!-- <div class="selection-summary" *ngIf="showSummary"> -->
    <div class="card card-left-accent">
      <div class="card-header">
        <div>
          <i class="fas fa-chart-bar"></i>
          {{ "selectionSummary" | translate}}
        </div>
      </div>


        <div class="summary-cards-grid p-3">
          <div class="card summary-card">
            <div class="card-body summary-card-body">
              <i class="fas fa-check-square me-2 text-success"></i>
              <div>
                <div class="summary-text">Dispositivos seleccionados</div>
                <div class="summary-value">{{selectedDeviceIds.length}} de {{allDevices.length}}</div>
              </div>
            </div>
          </div>

          <div class="card summary-card">
            <div class="card-body summary-card-body">
              <i class="fas fa-wifi me-2 text-success"></i>
              <div>
                <div class="summary-text">Estado</div>
                <div class="summary-value">{{ getOnlineDevicesCount() }} / {{ selectedDeviceIds.length }} online</div>
              </div>
            </div>
          </div>

          <div class="card summary-card">
            <div class="card-body summary-card-body">
              <i class="fas fa-microchip me-2 text-info"></i>
              <div>
                <div class="summary-text">Tipos</div>
                <div class="summary-value" [class.text-muted]="resumeDevices.length === 0">
                  {{getSelectedDeviceTypesText()}}
                </div>
              </div>
            </div>
          </div>

          <div class="card summary-card">
            <div class="card-body summary-card-body">
              <i class="fas fa-bolt me-2 text-warning"></i>
              <div>
                <div class="summary-text">Consumo total</div>
                <div class="summary-value">{{getTotalSelectedEnergy() | number:'1.2-2'}} kWh</div>
              </div>
            </div>
          </div>

          <div class="card summary-card">
            <div class="card-body summary-card-body">
              <i class="fas fa-tachometer-alt me-2 text-primary"></i>
              <div>
                <div class="summary-text">Potencia actual total</div>
                <div class="summary-value">{{getTotalCurrentPower() | number:'1.2-2'}} kW</div>
              </div>
            </div>
          </div>

          <div class="card summary-card">
            <div class="card-body summary-card-body">
              <i class="fas fa-rocket me-2 text-danger"></i>
              <div>
                <div class="summary-text">Potencia máxima total</div>
                <div class="summary-value">{{getTotalMaxPower() | number:'1.2-2'}} kW</div>
              </div>
            </div>
          </div>
        </div>


        <!-- Gráfico de energía por dispositivo -->
        <div class="chart-container m-3 mt-0">
          <div class="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
            <h6 class="mb-0 fw-semibold text-dark">
              <i class="fas me-2" [ngClass]="currentChartType === 'bar' ? 'fa-chart-bar' : 'fa-chart-pie'"></i>
              {{ currentChartType === 'bar' ? 'Energía por Dispositivo' : 'Proporción de Energía' }}
            </h6>

            <div class="d-flex gap-2">
              <button
                class="btn btn-sm btn-outline-secondary chart-toggle-btn"
                [class.active]="currentChartType === 'bar'"
                (click)="switchChartType('bar')"
                title="Gráfico de barras">
                <i class="fas fa-chart-bar"></i>
              </button>
              <button
                class="btn btn-sm btn-outline-secondary chart-toggle-btn"
                [class.active]="currentChartType === 'doughnut'"
                (click)="switchChartType('doughnut')"
                title="Gráfico de dona">
                <i class="fas fa-chart-pie"></i>
              </button>
            </div>
          </div>

          <div class="chart-wrapper">
            <canvas #chartCanvas></canvas>
          </div>
        </div>

        <!-- Mensaje cuando no hay dispositivos seleccionados -->
        <div class="no-selection-message" *ngIf="selectedDeviceIds.length === 0">
          <div class="text-center text-muted py-4">
              <i class="fas me-2 fa-3x mb-3 opacity-50" [ngClass]="currentChartType === 'bar' ? 'fa-chart-bar' : 'fa-chart-pie'" ></i>
            <p class="mb-0">Selecciona dispositivos para ver el gráfico de energía</p>
          </div>
        </div>




<!-- Modal de información del dispositivo -->
<div class="modal fade" id="deviceInfoModal" tabindex="-1" aria-labelledby="deviceInfoModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white" style="background-color: var(--bs-primary) !important; color: white !important;">
        <h5 class="modal-title" id="deviceInfoModalLabel" style="color: white !important;">
          <i class="fa-solid fa-circle-info me-2" style="color: white !important;"></i>
          {{ "deviceInformation" | translate }}
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" style="font-size: 1.5rem; "></button>
      </div>

      <div class="modal-body" *ngIf="selectedDevice">
        <!-- Información principal del dispositivo -->
        <div class="device-main-info mb-4">
          <div class="row">
            <div class="col-md-8">
              <h6 class="fw-bold text-primary mb-3">
                <i class="fa-solid fa-microchip me-2"></i>
                {{ "mainDevice" | translate }}
              </h6>

              <div class="info-grid">
                <div class="info-item">
                  <span class="info-label">{{ "deviceName" | translate }}:</span>
                  <span class="info-value">{{ selectedDevice.name || selectedDevice.serial }}</span>
                </div>

                <div class="info-item">
                  <span class="info-label">{{ "serialNumber" | translate }}:</span>
                  <span class="info-value">{{ selectedDevice.serial }}</span>
                </div>

                <div class="info-item">
                  <span class="info-label">{{ "connectionStatus" | translate }}:</span>
                  <span class="info-value" [ngClass]="selectedDevice.alive ? 'text-success' : 'text-danger'">
                    <i class="fa-solid fa-wifi me-1"></i>
                    {{ selectedDevice.alive ? ("online" | translate) : ("offline" | translate) }}
                  </span>
                </div>

                <div class="info-item">
                  <span class="info-label">{{ "lastUpdate" | translate }}:</span>
                  <span class="info-value">{{ selectedDevice.lastUpdate | date:'medium' }}</span>
                </div>

                <div class="info-item">
                  <span class="info-label">{{ "totalEnergy" | translate }}:</span>
                  <span class="info-value fw-bold text-success">
                    <i class="fa-solid fa-bolt me-1"></i>
                    {{ selectedDevice.totalEnergy | number:'1.2-2' }} kWh
                  </span>
                </div>

                <div class="info-item">
                  <span class="info-label">{{ "firmware" | translate }}:</span>
                  <span class="info-value fw-bold text-primary">
                    <i class="fa-solid fa-microchip me-1"></i>
                    {{ selectedDevice.fw }}
                  </span>
                </div>
              </div>
            </div>

            <div class="col-md-4 text-center">
              <img *ngIf="selectedDevice.serial.includes('EVVC3')" src="./../../../../assets/img/orbis/uni.png" alt="uni" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <img *ngIf="selectedDevice.serial.includes('EVVC4')" src="./../../../../assets/img/orbis/combiplus.png" alt="combiplus" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <img *ngIf="selectedDevice.serial.includes('EVVC5')" src="./../../../../assets/img/orbis/city+2.png" alt="city+2" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <img *ngIf="selectedDevice.serial.includes('EVVC1')" src="./../../../../assets/img/orbis/combi.png" alt="combi" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <img *ngIf="selectedDevice.serial.includes('EVVC6')" src="./../../../../assets/img/orbis/exo.png" alt="exo" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <img *ngIf="selectedDevice.serial.includes('XEO')" src="./../../../../assets/img/orbis/xeo+_2 2.png" alt="XEO" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <img *ngIf="selectedDevice.serial.includes('ANC')" src="./../../../../assets/img/orbis/ANC.png" alt="ANC" class="device-image img-fluid mb-2" style="max-height: 120px;">
              <div class="device-status-badge">
                <span class="badge" [ngClass]="selectedDevice.alive ? 'bg-success' : 'bg-danger'">
                  {{ selectedDevice.alive ? ("active" | translate) : ("inactive" | translate) }}
                </span>
              </div>
            </div>
          </div>
        </div>

                <!-- Datos por Fases (solo para XeoLum trifásicos) -->
        <div class="phase-data-section" *ngIf="selectedDevice.type === 'XEO' && selectedDevice.phases">
          <div class="phase-data-header">
            <i class="fa-solid fa-bolt-lightning me-2 text-warning"></i>
            Datos Trifásicos (R, S, T)
          </div>

          <!-- Tensiones de Fase -->
          <div class="mb-4">
            <h6 class="text-secondary mb-3">
              <i class="fa-solid fa-plug me-2"></i>
              Tensiones de Fase
            </h6>
            <div class="phase-values-grid">
              <div class="phase-card phase-R">
                <div class="phase-label">Fase R</div>
                <div class="phase-value">{{ selectedDevice.phases.voltages.phases.R | number:'1.1-1' }}</div>
                <div class="phase-unit">V</div>
              </div>
              <div class="phase-card phase-S">
                <div class="phase-label">Fase S</div>
                <div class="phase-value">{{ selectedDevice.phases.voltages.phases.S | number:'1.1-1' }}</div>
                <div class="phase-unit">V</div>
              </div>
              <div class="phase-card phase-T">
                <div class="phase-label">Fase T</div>
                <div class="phase-value">{{ selectedDevice.phases.voltages.phases.T | number:'1.1-1' }}</div>
                <div class="phase-unit">V</div>
              </div>
            </div>
          </div>

          <!-- Corrientes de Fase -->
          <div class="mb-4">
            <h6 class="text-secondary mb-3">
              <i class="fa-solid fa-gauge me-2"></i>
              Corrientes de Fase
            </h6>
            <div class="phase-values-grid">
              <div class="phase-card phase-R">
                <div class="phase-label">Fase R</div>
                <div class="phase-value">{{ selectedDevice.phases.currents.phases.R | number:'1.1-1' }}</div>
                <div class="phase-unit">A</div>
              </div>
              <div class="phase-card phase-S">
                <div class="phase-label">Fase S</div>
                <div class="phase-value">{{ selectedDevice.phases.currents.phases.S | number:'1.1-1' }}</div>
                <div class="phase-unit">A</div>
              </div>
              <div class="phase-card phase-T">
                <div class="phase-label">Fase T</div>
                <div class="phase-value">{{ selectedDevice.phases.currents.phases.T | number:'1.1-1' }}</div>
                <div class="phase-unit">A</div>
              </div>
            </div>
          </div>

          <!-- Potencias por Fase -->
          <div class="mb-4">
            <h6 class="text-secondary mb-3">
              <i class="fa-solid fa-flash me-2"></i>
              Potencias Activas por Fase
            </h6>
            <div class="phase-values-grid">
              <div class="phase-card phase-R">
                <div class="phase-label">Fase R</div>
                <div class="phase-value">{{ selectedDevice.phases.powers.active.R | number:'1.2-2' }}</div>
                <div class="phase-unit">kW</div>
              </div>
              <div class="phase-card phase-S">
                <div class="phase-label">Fase S</div>
                <div class="phase-value">{{ selectedDevice.phases.powers.active.S | number:'1.2-2' }}</div>
                <div class="phase-unit">kW</div>
              </div>
              <div class="phase-card phase-T">
                <div class="phase-label">Fase T</div>
                <div class="phase-value">{{ selectedDevice.phases.powers.active.T | number:'1.2-2' }}</div>
                <div class="phase-unit">kW</div>
              </div>
            </div>

            <!-- Resumen de Potencias Totales -->
            <div class="power-summary">
              <div class="power-summary-grid">
                <div class="power-total-item">
                  <div class="label">Activa Total</div>
                  <div class="value">{{ selectedDevice.phases.powers.total.active | number:'1.2-2' }} kW</div>
                </div>
                <div class="power-total-item">
                  <div class="label">Reactiva Total</div>
                  <div class="value">{{ selectedDevice.phases.powers.total.reactive | number:'1.2-2' }} kVAR</div>
                </div>
                <div class="power-total-item">
                  <div class="label">Aparente Total</div>
                  <div class="value">{{ selectedDevice.phases.powers.total.apparent | number:'1.2-2' }} kVA</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Factor de Potencia y Frecuencia -->
          <div class="row">
            <div class="col-md-8">
              <h6 class="text-secondary mb-3">
                <i class="fa-solid fa-chart-line me-2"></i>
                Factor de Potencia por Fase
              </h6>
              <div class="phase-values-grid">
                <div class="phase-card phase-R">
                  <div class="phase-label">Fase R</div>
                  <div class="phase-value">{{ selectedDevice.phases.powerFactor.R | number:'1.3-3' }}</div>
                  <div class="phase-unit">cos φ</div>
                </div>
                <div class="phase-card phase-S">
                  <div class="phase-label">Fase S</div>
                  <div class="phase-value">{{ selectedDevice.phases.powerFactor.S | number:'1.3-3' }}</div>
                  <div class="phase-unit">cos φ</div>
                </div>
                <div class="phase-card phase-T">
                  <div class="phase-label">Fase T</div>
                  <div class="phase-value">{{ selectedDevice.phases.powerFactor.T | number:'1.3-3' }}</div>
                  <div class="phase-unit">cos φ</div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <h6 class="text-secondary mb-3">
                <i class="fa-solid fa-wave-square me-2"></i>
                Frecuencia de Red
              </h6>
              <div class="frequency-indicator">
                <i class="fa-solid fa-sync-alt"></i>
                {{ selectedDevice.phases.frequency | number:'1.2-2' }} Hz
              </div>
            </div>
          </div>
        </div>

        <!-- Zona Geográfica (solo para ANC) -->
        <div class="geographic-zone-section mb-4" *ngIf="selectedDevice.type === 'ANC' && selectedDevice.schedule">
          <h6 class="fw-bold text-primary mb-3">
            <i class="fa-solid fa-globe me-2"></i>
            Zona Geográfica
          </h6>
          <div class="alert alert-info d-flex align-items-center p-1" role="alert">
            <i class="fa-solid fa-clock fa-2x me-3 text-primary"></i>
            <strong class="fs-5">{{ selectedDevice.schedule.timezone }}</strong>
          </div>
        </div>

        <!-- Estados de salida -->
        <div class="outputs-section mb-4" *ngIf="selectedDevice.schedule">
          <h6 class="fw-bold text-primary mb-3">
            <i class="fa-solid fa-toggle-on me-2"></i>
            {{ "outputStatus" | translate }}
          </h6>

          <div class="row">
            <div class="col-md-6" *ngFor="let output of getOutputsArray(); let i = index">
              <div class="output-card">
                <div class="output-header">
                  <span class="output-label">{{ "output" | translate }} {{ i + 1 }}</span>
                  <span class="output-status" [ngClass]="output?.enabled ? 'text-success' : 'text-danger'">
                    <i class="fa-solid fa-circle"></i>
                    {{ output?.enabled ? ("enabled" | translate) : ("disabled" | translate) }}
                  </span>
                </div>
                <div class="output-details" *ngIf="output?.values">
                  <div class="output-value">
                    <span class="value-label">{{ "power" | translate }}:</span>
                    <span class="value-number">{{ output.values.power }}W</span>
                  </div>
                  <div class="output-value">
                    <span class="value-label">{{ "voltage" | translate }}:</span>
                    <span class="value-number">{{ output.values.voltage }}V</span>
                  </div>
                  <div class="output-value">
                    <span class="value-label">{{ "current" | translate }}:</span>
                    <span class="value-number">{{ output.values.current }}A</span>
                  </div>
                  <div class="output-value">
                    <span class="value-label">{{ "maxPower" | translate }}:</span>
                    <span class="value-number">{{ output.values.maxPower }}W</span>
                  </div>

                  <div class="output-value">
                    <span class="value-label">Programación:</span>
                  </div>

                  <!-- Cada programación en una fila -->
                  <div class="schedules-list">
                    <div *ngFor="let rule of output.rules; let j = index" class="schedule-row">
                      <div *ngIf="output.rules[j].length === 0">
                        <div class="text-muted"> No hay programación </div>
                      </div>
                      <div *ngIf="output.rules[j].length != 0" class="schedule-content-inline">
                        <!-- Círculos para días de la semana -->
                        <div class="days-circles-container">
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 1)">L</div>
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 2)">M</div>
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 4)">X</div>
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 8)">J</div>
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 16)">V</div>
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 32)">S</div>
                          <div class="day-circle" [class.active]="isDayActive(output.rules[j].daysOfWeek, 64)">D</div>
                        </div>

                        <!-- Horarios -->
                        <div class="schedule-time">
                          <strong>{{output.rules[j].start}}</strong> →
                          <strong>{{output.rules[j].end}}</strong>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
            </div>
          </div>
        </div>        <!-- Información de satélites -->
        <div class="satellites-section" *ngIf="selectedDevice.satelites && selectedDevice.satelites.length > 0">
          <h6 class="fw-bold text-primary mb-3">
            <i class="fa-solid fa-satellite me-2"></i>
            {{ "satellites" | translate }} ({{ selectedDevice.satelites.length }})
          </h6>

          <div class="satellites-grid">
            <div class="satellite-card" *ngFor="let satellite of selectedDevice.satelites; let i = index">
              <div class="satellite-header">
                <div class="satellite-info">
                  <span class="satellite-id fw-bold">{{ "satellite" | translate }} {{ satellite.id }}</span>
                  <span class="satellite-status" [ngClass]="satellite.alive ? 'text-success' : 'text-danger'">
                    <i class="fa-solid fa-circle"></i>
                    {{ satellite.alive ? ("online" | translate) : ("offline" | translate) }}
                  </span>
                </div>
                <img src="./../../../../assets/img/orbis/XeoSwitch 1.png" alt="Satellite" class="satellite-image" style="height: 40px;">
              </div>

              <div class="satellite-details">
                <div class="detail-row">
                  <span class="detail-label">{{ "name" | translate }}:</span>
                  <span class="detail-value">{{ satellite.name }}</span>
                </div>

                <div class="metrics-row">
                  <div class="metric">
                    <span class="metric-label">{{ "voltage" | translate }}</span>
                    <span class="metric-value text-primary fw-bold">{{ satellite.voltage }}V</span>
                  </div>

                  <div class="metric">
                    <span class="metric-label">{{ "current" | translate }}</span>
                    <span class="metric-value text-warning fw-bold">{{ satellite.current }}A</span>
                  </div>

                  <div class="metric">
                    <span class="metric-label">{{ "power" | translate }}</span>
                    <span class="metric-value text-success fw-bold">{{ satellite.power }}W</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Mensaje si no hay satélites (solo para XeoLum sin satélites) -->
        <div class="no-satellites" *ngIf="selectedDevice.serial.includes('XEO') && (!selectedDevice.satelites || selectedDevice.satelites.length === 0)">
          <div class="text-center text-muted py-4">
            <i class="fa-solid fa-satellite-dish fa-3x mb-3 opacity-50"></i>
            <p class="mb-0">{{ "noSatellitesConnected" | translate }}</p>
          </div>
        </div>


      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          <i class="fa-solid fa-xmark me-2"></i>
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
</div>

<!-- Modal de gráfico del dispositivo -->
<div class="modal fade" id="deviceStatsModal" tabindex="-1" aria-labelledby="deviceStatsModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white"
        style="background-color: var(--bs-primary) !important; color: white !important;">
        <h5 class="modal-title" id="deviceStatsModalLabel" style="color: white !important;">
          <i class="fa-solid fa-chart-line me-2" style="color: white !important;"></i>
          Gráfico de energía del dispositivo
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"
          style="font-size: 1.5rem; "></button>
      </div>

      <div class="modal-body" *ngIf="selectedDevice">
        <!-- Información del dispositivo -->
        <div class="mb-4">
          <div class="row align-items-center">
            <div class="col-md-8">
              <h6 class="fw-bold mb-1">
                <i class="fa-solid fa-microchip me-2 text-primary"></i>
                {{ selectedDevice.name || selectedDevice.serial }}
              </h6>
              <p class="text-muted mb-0 small">
                <i class="fa-solid fa-barcode me-1"></i>
                {{ selectedDevice.serial }}
                <span class="ms-3">
                  <i class="fa-solid fa-wifi me-1" [ngClass]="selectedDevice.alive ? 'text-success' : 'text-danger'"></i>
                  {{ selectedDevice.alive ? ("online" | translate) : ("offline" | translate) }}
                </span>
              </p>
            </div>
            <div class="col-md-4 text-end">
              <div class="d-flex justify-content-end gap-2">
                <div class="text-center px-3 py-2 border rounded bg-light">
                  <small class="text-muted d-block">{{ "totalEnergy" | translate }}</small>
                  <strong class="text-success">{{ selectedDevice.totalEnergy | number:'1.2-2' }} kWh</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Controles del gráfico -->
        <div class="mb-3" *ngIf="selectedDevice.history">
          <div class="d-flex justify-content-between align-items-center">
            <div class="btn-group" role="group">
              <button type="button" class="btn btn-sm"
                [class.btn-primary]="selectedHistoryChart === 'energy'"
                [class.btn-outline-primary]="selectedHistoryChart !== 'energy'"
                (click)="changeHistoryChart('energy')"
                title="Muestra barras de energía + línea de media">
                <i class="fa-solid fa-bolt me-1"></i>
                {{ "energy" | translate }}
              </button>
              <button type="button" class="btn btn-sm"
                [class.btn-primary]="selectedHistoryChart === 'power'"
                [class.btn-outline-primary]="selectedHistoryChart !== 'power'"
                (click)="changeHistoryChart('power')"
                title="Muestra barras de potencia + línea de potencia máxima">
                <i class="fa-solid fa-flash me-1"></i>
                {{ "power" | translate }}
              </button>
              <button type="button" class="btn btn-sm"
                [class.btn-primary]="selectedHistoryChart === 'voltage'"
                [class.btn-outline-primary]="selectedHistoryChart !== 'voltage'"
                (click)="changeHistoryChart('voltage')"
                title="Muestra barras de voltaje">
                <i class="fa-solid fa-plug me-1"></i>
                {{ "voltage" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- Canvas del gráfico -->
        <div class="chart-section mb-4" *ngIf="selectedDevice.history">
          <div class="border rounded p-3" style="min-height: 350px;">
            <canvas #deviceHistoryChart></canvas>
          </div>
        </div>

        <!-- Mensaje cuando no hay historial -->
        <div class="alert alert-info mb-4" *ngIf="!selectedDevice.history">
          <i class="fa-solid fa-info-circle me-2"></i>
          Este dispositivo no tiene datos históricos disponibles.
        </div>

        <!-- Estadísticas rápidas -->
        <div class="mb-3 mt-4">
          <h6 class="fw-bold text-secondary">
            <i class="fa-solid fa-gauge-high me-2"></i>
            Valores Instantáneos
          </h6>
          <hr class="mt-2 mb-3">
        </div>

        <div class="row g-3">
          <!-- Para equipos trifásicos (XEO), mostrar valores por fases -->
          <ng-container *ngIf="selectedDevice.type === 'XEO' && selectedDevice.phases; else monophasicValues">
            <!-- Potencia por fases -->
            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-bolt fa-2x text-warning mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "power" | translate }}</h6>
                <div class="phase-values-compact">
                  <div class="phase-value-item">
                    <span class="phase-label-r">R:</span>
                    <span class="phase-value">{{ selectedDevice.phases.powers.active.R | number:'1.2-2' }}kW</span>
                  </div>
                  <div class="phase-value-item">
                    <span class="phase-label-s">S:</span>
                    <span class="phase-value">{{ selectedDevice.phases.powers.active.S | number:'1.2-2' }}kW</span>
                  </div>
                  <div class="phase-value-item">
                    <span class="phase-label-t">T:</span>
                    <span class="phase-value">{{ selectedDevice.phases.powers.active.T | number:'1.2-2' }}kW</span>
                  </div>
                </div>
                <hr class="my-2">
                <h6 class="fw-bold mb-0 text-warning">Total: {{ selectedDevice.phases.powers.total.active | number:'1.2-2' }}kW</h6>
              </div>
            </div>

            <!-- Tensión por fases -->
            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-plug fa-2x text-primary mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "voltage" | translate }}</h6>
                <div class="phase-values-compact">
                  <div class="phase-value-item">
                    <span class="phase-label-r">R:</span>
                    <span class="phase-value">{{ selectedDevice.phases.voltages.phases.R | number:'1.1-1' }}V</span>
                  </div>
                  <div class="phase-value-item">
                    <span class="phase-label-s">S:</span>
                    <span class="phase-value">{{ selectedDevice.phases.voltages.phases.S | number:'1.1-1' }}V</span>
                  </div>
                  <div class="phase-value-item">
                    <span class="phase-label-t">T:</span>
                    <span class="phase-value">{{ selectedDevice.phases.voltages.phases.T | number:'1.1-1' }}V</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Corriente por fases -->
            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-gauge fa-2x text-info mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "current" | translate }}</h6>
                <div class="phase-values-compact">
                  <div class="phase-value-item">
                    <span class="phase-label-r">R:</span>
                    <span class="phase-value">{{ selectedDevice.phases.currents.phases.R | number:'1.2-2' }}A</span>
                  </div>
                  <div class="phase-value-item">
                    <span class="phase-label-s">S:</span>
                    <span class="phase-value">{{ selectedDevice.phases.currents.phases.S | number:'1.2-2' }}A</span>
                  </div>
                  <div class="phase-value-item">
                    <span class="phase-label-t">T:</span>
                    <span class="phase-value">{{ selectedDevice.phases.currents.phases.T | number:'1.2-2' }}A</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Temperatura (mismo para trifásicos) -->
            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-temperature-half fa-2x text-danger mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "temperature" | translate }}</h6>
                <h5 class="fw-bold mb-0">{{ selectedDevice.temperature | number:'1.0-0' }} °C</h5>
              </div>
            </div>
          </ng-container>

          <!-- Para equipos monofásicos (ANC, XeoSwitch) -->
          <ng-template #monophasicValues>
            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-bolt fa-2x text-warning mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "power" | translate }}</h6>
                <h5 class="fw-bold mb-0">{{ selectedDevice.power | number:'1.2-2' }} W</h5>
              </div>
            </div>

            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-plug fa-2x text-primary mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "voltage" | translate }}</h6>
                <h5 class="fw-bold mb-0">{{ selectedDevice.voltage | number:'1.1-1' }} V</h5>
              </div>
            </div>

            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-gauge fa-2x text-info mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "current" | translate }}</h6>
                <h5 class="fw-bold mb-0">{{ selectedDevice.current | number:'1.2-2' }} A</h5>
              </div>
            </div>

            <div class="col-md-3">
              <div class="stat-card text-center p-3 border rounded bg-light">
                <i class="fa-solid fa-temperature-half fa-2x text-danger mb-2"></i>
                <h6 class="text-muted small mb-1">{{ "temperature" | translate }}</h6>
                <h5 class="fw-bold mb-0">{{ selectedDevice.temperature | number:'1.0-0' }} °C</h5>
              </div>
            </div>
          </ng-template>
        </div>

        <!-- Información de satélites si existen -->
        <div class="mt-4" *ngIf="selectedDevice.satelites && selectedDevice.satelites.length > 0">
          <h6 class="fw-bold mb-3">
            <i class="fa-solid fa-satellite me-2 text-info"></i>
            {{ "satellites" | translate }} ({{ selectedDevice.satelites.length }})
          </h6>
          <div class="row g-2">
            <div class="col-md-6" *ngFor="let satellite of selectedDevice.satelites">
              <div class="border rounded p-2 d-flex align-items-center justify-content-between">
                <div>
                  <strong class="d-block">{{ satellite.name }}</strong>
                  <small class="text-muted">{{ satellite.id }}</small>
                </div>
                <div class="text-end">
                  <div class="small">
                    <i class="fa-solid fa-bolt text-warning"></i> {{ satellite.power }} W
                  </div>
                  <span class="badge" [ngClass]="satellite.alive ? 'bg-success' : 'bg-secondary'">
                    {{ satellite.alive ? ("online" | translate) : ("offline" | translate) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer bg-light">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          <i class="fa-solid fa-xmark me-2"></i>
          {{ "close" | translate }}
        </button>
        <button type="button" class="btn btn-primary" (click)="exportDeviceHistory()" [disabled]="!selectedDevice?.history">
          <i class="fa-solid fa-download me-2"></i>
          {{ "export" | translate }} CSV
        </button>
      </div>
    </div>
  </div>
</div>
